import { todayPT } from "@homebound/activesupport";
import { RouteTabWithContent, TabContent, Tabs } from "@homebound/beam";
import { FinancesPageSharedQuery, useFinancesPageSharedQuery } from "src/routes/billing/FinancesPage.generated";
import { BillsPage } from "src/routes/bills/BillsPage";
import { InvoicesPage } from "src/routes/invoices/InvoicesPage";
import { PageHeader } from "src/routes/layout/PageHeader";
import { billsPath, invoiceTermsPath, invoicesPath, lienWaiversPath, purchaseOrdersPath } from "src/routes/routesDef";
import { DateFilterOperation, queryResult } from "src/utils";
import { PurchaseOrdersPage } from "../developments/purchase-orders/PurchaseOrdersPage";
import { LienWaiversPage } from "../lien-waivers/LienWaiversPage";
import { InvoiceTermsPage } from "./invoice-terms/InvoiceTermsPage";

export function FinancesPage() {
  const query = useFinancesPageSharedQuery();
  return queryResult(query, { data: (data) => <FinancesPageFilterDataView shared={data} /> });
}

type FinancesPageFilterDataViewProps = { shared: FinancesPageSharedQuery };

function FinancesPageFilterDataView({ shared }: FinancesPageFilterDataViewProps) {
  const tabs: RouteTabWithContent[] = [
    { name: "Bills & Credits", href: billsPath, path: billsPath, render: () => <BillsPage shared={shared} /> },
    { name: "Invoices", href: invoicesPath, path: invoicesPath, render: () => <InvoicesPage shared={shared} /> },
    {
      name: "Purchase Orders",
      href: purchaseOrdersPath,
      path: purchaseOrdersPath,
      render: () => <PurchaseOrdersPage isGlobal={true} />,
    },
    { name: "Invoice Terms", href: invoiceTermsPath, path: invoiceTermsPath, render: () => <InvoiceTermsPage /> },
    {
      name: "Lien Waivers",
      href: lienWaiversPath,
      path: lienWaiversPath,
      render: () => <LienWaiversPage shared={shared} />,
    },
  ];

  return (
    <>
      <PageHeader title="Finances" hideTitle left={<Tabs tabs={tabs} />} />
      <TabContent tabs={tabs} />
    </>
  );
}

export const financesDefaultFilter = {
  dueDate: { op: DateFilterOperation.Before, value: todayPT().add({ months: 1 }) },
};
